<template>
    <modal id="b2b-partner-modal" size="extra-large" v-model="showModal" :loading="loading" :preloader="preloader"
        :title="generateModalTitle('b2b_partner')" @submit="submitData">
        <form ref="form" :data-url="selectedUrl ? selectedUrl : B2B_PARTNERS" @submit.prevent="submitData">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('B2B Partner Name')" :required="true"
                        :error-message="$errorMessage(errors, 'name')" :placeholder="$placeholder('B2B Partner Name')"
                        v-model="formData.name" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Company Name')"
                        :error-message="$errorMessage(errors, 'company_name')" :placeholder="$placeholder('Company Name')"
                        v-model="formData.company_name" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group type="select" :list="branchList" list-value-field="value" :page="'modal'"
                        :label="$t('Branch')" :error-message="$errorMessage(errors, 'branch_id')"
                        :placeholder="$placeholder('Select Branch')" v-model="formData.branch_id" />
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('GSTIN')"
                        :error-message="$errorMessage(errors, 'gstin')" :placeholder="$placeholder('GSTIN')"
                        v-model="formData.gstin" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Email')"
                        :error-message="$errorMessage(errors, 'email')" :placeholder="$placeholder('Email')"
                        v-model="formData.email" />
                </div>

                <!-- Phone (with optional second number) -->
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group type="number" :page="'modal'" :label="$t('Phone')"
                        :error-message="$errorMessage(errors, 'phone_1')" :placeholder="$placeholder('Phone')"
                        v-model="formData.phone_1" />
                    <a v-if="!showSecondPhone" href="javascript:void(0)" class="small" @click="showSecondPhone = true">
                        + {{ $t('Add another number') }}
                    </a>
                </div>
                <div class="col-12 col-sm-6 col-md-4" v-if="showSecondPhone">
                    <app-form-group type="number" :page="'modal'" :label="$t('Phone 2')"
                        :error-message="$errorMessage(errors, 'phone_2')" :placeholder="$placeholder('Phone 2')"
                        v-model="formData.phone_2" />
                </div>

                <!-- Billing Address -->
                <div class="col-12"><hr class="my-2"><strong class="d-block mb-2">{{ $t('Billing Address') }}</strong></div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Address line 1')" v-model="formData.billing_line_1"
                        :placeholder="$placeholder('Address line 1')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Address line 2')" v-model="formData.billing_line_2"
                        :placeholder="$placeholder('Address line 2')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Address line 3')" v-model="formData.billing_line_3"
                        :placeholder="$placeholder('Address line 3')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('City')" v-model="formData.billing_city"
                        :placeholder="$placeholder('City')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group type="number" :page="'modal'" :label="$t('PIN')" v-model="formData.billing_pin"
                        :placeholder="$placeholder('PIN')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group type="select" :list="statesList" list-value-field="value" :page="'modal'"
                        :label="$t('State')" :placeholder="$placeholder('State')" v-model="formData.billing_state_id" />
                </div>

                <!-- Default shipping / bill to -->
                <div class="col-12 col-sm-6 col-md-6">
                    <app-form-group type="radio" radio-checkbox-name="default_shipping" :label="$t('Default Shipping')"
                        :list="[{ id: 'partner', value: $t('Ship to Partner') }, { id: 'patient', value: $t('Ship to Patient') }]"
                        v-model="formData.default_shipping" />
                </div>
                <div class="col-12 col-sm-6 col-md-6">
                    <app-form-group type="radio" radio-checkbox-name="default_bill_to" :label="$t('Default Bill To')"
                        :list="[{ id: 'partner', value: $t('Partner') }, { id: 'patient', value: $t('Patient') }]"
                        v-model="formData.default_bill_to" />
                </div>

                <!-- Address 1 -->
                <div class="col-12"><hr class="my-2"><strong class="d-block mb-2">{{ $t('Address 1') }}</strong></div>
                <div class="col-12 mb-2">
                    <app-form-group type="radio" radio-checkbox-name="addr1_title" :label="$t('Address Title')" :required="true"
                        :list="[
                            { id: 'None', value: $t('None') },
                            { id: 'Partner Home', value: $t('Partner Home') },
                            { id: 'Partner Work', value: $t('Partner Work') },
                            { id: 'Partner Other', value: $t('Partner Other') }
                        ]" v-model="formData.addr1_title"
                        :error-message="$errorMessage(errors, 'addr1_title')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Line 1')" v-model="formData.addr1_line_1"
                        :placeholder="$placeholder('Line 1')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Line 2')" v-model="formData.addr1_line_2"
                        :placeholder="$placeholder('Line 2')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Line 3')" v-model="formData.addr1_line_3"
                        :placeholder="$placeholder('Line 3')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('City')" v-model="formData.addr1_city"
                        :placeholder="$placeholder('City')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group type="number" :page="'modal'" :label="$t('PIN')" v-model="formData.addr1_pin"
                        :placeholder="$placeholder('PIN')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group type="select" :list="statesList" list-value-field="value" :page="'modal'"
                        :label="$t('State')" :placeholder="$placeholder('State')" v-model="formData.addr1_state_id" />
                </div>

                <!-- Address 2 -->
                <div class="col-12"><hr class="my-2"><strong class="d-block mb-2">{{ $t('Address 2') }}</strong></div>
                <div class="col-12 mb-2">
                    <app-form-group type="radio" radio-checkbox-name="addr2_title" :label="$t('Address Title')" :required="true"
                        :list="[
                            { id: 'None', value: $t('None') },
                            { id: 'Partner Home', value: $t('Partner Home') },
                            { id: 'Partner Work', value: $t('Partner Work') },
                            { id: 'Partner Other', value: $t('Partner Other') }
                        ]" v-model="formData.addr2_title"
                        :error-message="$errorMessage(errors, 'addr2_title')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Line 1')" v-model="formData.addr2_line_1"
                        :placeholder="$placeholder('Line 1')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Line 2')" v-model="formData.addr2_line_2"
                        :placeholder="$placeholder('Line 2')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('Line 3')" v-model="formData.addr2_line_3"
                        :placeholder="$placeholder('Line 3')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group :page="'modal'" :label="$t('City')" v-model="formData.addr2_city"
                        :placeholder="$placeholder('City')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group type="number" :page="'modal'" :label="$t('PIN')" v-model="formData.addr2_pin"
                        :placeholder="$placeholder('PIN')" />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <app-form-group type="select" :list="statesList" list-value-field="value" :page="'modal'"
                        :label="$t('State')" :placeholder="$placeholder('State')" v-model="formData.addr2_state_id" />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import CoreLibrary from "../../../../core/helpers/CoreLibrary";
import { B2B_PARTNERS } from "../../../Config/ApiUrl-CPB";
import { SELECTABLE_STATES } from "../../../Config/ApiUrl-CP";
import { axiosGet } from "../../../../common/Helper/AxiosHelper";

export default {
    name: "B2bPartnerCreateEditModal",
    extends: CoreLibrary,
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            B2B_PARTNERS,
            branchList: [],
            statesList: [],
            showSecondPhone: false,
            formData: {
                default_shipping: 'partner',
                default_bill_to: 'partner',
                branch_id: '',
                addr1_title: 'None',
                addr2_title: 'None',
                addr1_state_id: '',
                addr2_state_id: '',
                billing_state_id: '',
            },
        };
    },
    created() {
        this.fetchBranches();
        this.fetchStates();
    },
    methods: {
        fetchBranches() {
            axiosGet('app/selectable/b2b-branches').then(response => {
                const items = (response.data && response.data.data) ? response.data.data : response.data;
                this.branchList = (Array.isArray(items) ? items : []).map(b => ({ id: b.id, value: b.name }));
            }).catch(() => {});
        },
        fetchStates() {
            axiosGet(`${SELECTABLE_STATES}`).then(response => {
                for (let item of (response.data.data || [])) {
                    this.statesList.push({ id: item.id, value: item.state });
                }
            }).catch(() => {});
        },
        submitData() {
            this.fieldStatus.isSubmit = true;
            this.loading = true;
            this.message = '';
            this.errors = {};
            this.save(this.formData);
        },
        afterSuccess({ data }) {
            this.formData = {};
            this.preloader = false;
            $('#b2b-partner-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'b2b-partners-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData = response.data;
            if (this.formData.phone_2) this.showSecondPhone = true;
        },
    },
}
</script>
